// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class UrlGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.SERVER_URL_GROUP, null, pfixFieldSet);
    }
    getProtocol() {
        return this.GetValue(FieldsFactory.FIELD_ADDRESS_PROTOCOL);
    }
    getValue() {
        return this.GetValue(FieldsFactory.FIELD_VALUE);
    }
}
